import React from 'react';
import PropTypes from 'prop-types';
import { motion, AnimatePresence } from 'framer-motion';
import { FaTimes, FaWhatsapp, FaGift, FaTrophy } from 'react-icons/fa';
import './WelcomeModal.css';

const WelcomeModal = ({ isOpen, onClose, language = 'fr' }) => {
    if (!isOpen) return null;

    const handleBackdropClick = (e) => {
        if (e.target === e.currentTarget) {
            onClose();
        }
    };

    const handleWhatsAppClick = () => {
        const phoneNumber = "237693127965";
        const message = language === 'fr' 
            ? "Bonjour! Je souhaite envoyer mes 10 tickets pour recevoir 500 Mo offerts."
            : "Hello! I want to send my 10 tickets to receive 500 MB offered.";
        
        const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
        window.open(whatsappUrl, '_blank');
    };

    return (
        <AnimatePresence>
            <motion.div 
                className="welcome-modal-backdrop"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                onClick={handleBackdropClick}
            >
                <motion.div 
                    className="welcome-modal-container"
                    initial={{ opacity: 0, scale: 0.8, y: 50 }}
                    animate={{ opacity: 1, scale: 1, y: 0 }}
                    exit={{ opacity: 0, scale: 0.8, y: 50 }}
                    transition={{ type: "spring", damping: 25, stiffness: 300 }}
                    onClick={(e) => e.stopPropagation()}
                >
                    {/* Header avec bouton fermer */}
                    <div className="welcome-modal-header">
                        <h2 className="welcome-modal-title">
                            <FaTrophy className="welcome-title-icon" />
                            {language === 'fr' ? 'Bienvenue sur GigaScore !' : 'Welcome to GigaScore!'}
                        </h2>
                        <button 
                            className="welcome-close-button"
                            onClick={onClose}
                            aria-label={language === 'fr' ? 'Fermer' : 'Close'}
                        >
                            <FaTimes />
                        </button>
                    </div>

                    {/* Contenu principal */}
                    <div className="welcome-modal-content">
                        {/* Message principal */}
                        <div className="welcome-main-message">
                            <FaGift className="welcome-gift-icon" />
                            <h3>
                                {language === 'fr' 
                                    ? 'Plus vous jouez, plus vous gagnez !' 
                                    : 'The more you play, the more you win!'}
                            </h3>
                        </div>

                        {/* Offre spéciale */}
                        <div className="welcome-offer">
                            <div className="offer-badge">
                                <span className="offer-number">10</span>
                                <span className="offer-text">
                                    {language === 'fr' ? 'participations' : 'participations'}
                                </span>
                            </div>
                            <span className="offer-equals">=</span>
                            <div className="offer-reward">
                                <span className="reward-amount">500 Mo</span>
                                <span className="reward-text">
                                    {language === 'fr' ? 'offerts' : 'offered'}
                                </span>
                            </div>
                        </div>

                        {/* Instructions */}
                        <div className="welcome-instructions">
                            <p>
                                {language === 'fr' 
                                    ? 'Que vous gagnez ou vous perdez, envoyez nous vos 10 tickets sur WhatsApp au ' 
                                    : 'Whether you win or lose, send us your 10 tickets on WhatsApp to '}
                                <strong>237693127965</strong>
                            </p>
                        </div>

                        {/* Bouton WhatsApp */}
                        <div className="welcome-actions">
                            <motion.button
                                className="whatsapp-button"
                                onClick={handleWhatsAppClick}
                                whileHover={{ scale: 1.05 }}
                                whileTap={{ scale: 0.95 }}
                            >
                                <FaWhatsapp className="whatsapp-icon" />
                                {language === 'fr' ? 'Contacter sur WhatsApp' : 'Contact on WhatsApp'}
                            </motion.button>
                            
                            <motion.button
                                className="continue-button"
                                onClick={onClose}
                                whileHover={{ scale: 1.02 }}
                                whileTap={{ scale: 0.98 }}
                            >
                                {language === 'fr' ? 'Commencer à jouer' : 'Start playing'}
                            </motion.button>
                        </div>
                    </div>
                </motion.div>
            </motion.div>
        </AnimatePresence>
    );
};

WelcomeModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    language: PropTypes.oneOf(['fr', 'en'])
};

export default WelcomeModal;